import { combineReducers } from 'redux';
import { createRouterReducer } from '@lagunovsky/redux-react-router'
import { reducer as formReducer } from 'redux-form';
import { createSelector } from 'reselect';

import auth, { isLoadingSelector as loadingAuthenticationSelector } from './auth';
import boardgames, { loadingSelector as loadingBoardgamesSelector } from './boardgames';
import categories, { loadingSelector as loadingCategoriesSelector } from './categories';
import notie from './notie';
import navigation from './navigation';
import statistics from './statistics';
import galleries from './galleries';
import secondHandBoardgames, { loadingSelector as loadingSecondHandBoardgameSelector } from './secondHandBoardgames';


const root = (history) => {
  return combineReducers({
    router: createRouterReducer(history),
    form: formReducer,
    navigation,
    auth,
    boardgames,
    notie,
    categories,
    statistics,
    galleries,
    secondHandBoardgames,
  });
};

export default root;

export const isLoadingSelector = createSelector(
  loadingBoardgamesSelector,
  loadingAuthenticationSelector,
  loadingCategoriesSelector,
  loadingSecondHandBoardgameSelector,
  (isBoardgamesLoading, isLoadingAuthentication, isCategoriesLoading, isSecondHandBoardgamesLoading) => 
    [isBoardgamesLoading, isLoadingAuthentication, isCategoriesLoading, isSecondHandBoardgamesLoading]
      .reduce((isLoading, isSectionLoading) => isLoading || isSectionLoading)
);

export const locationSelector = (state) => state.router.location;
